import { isIOS, isAndroid, isDesktop, isMobile } from 'react-device-detect';
const isWebview = require('is-ua-webview');
const MMT_ANDROID_PACKAGE = 'com.makemytrip';

export const getDeviceTypeString = () => {
  if (isDesktop) return 'DESKTOP_WEB';
  if (isMobile && isAndroid && isWebview(navigator.userAgent)) return 'ANDROID_APP';
  if (isMobile && isIOS && isWebview(navigator.userAgent)) return 'IOS_APP';
  if (isMobile) return 'MOBILE_WEB';
  return '';
};

export const isAppInstalled = async () => {
  try {
    if (navigator?.getInstalledRelatedApps) {
      const response = await navigator.getInstalledRelatedApps();

      if (response?.length > 0) {
        let appInstalled = false;
        response.forEach((eachItem) => {
          if (eachItem?.id === MMT_ANDROID_PACKAGE) {
            appInstalled = true;
          }
        });
        if (appInstalled) {
          return true;
        }
      }
      return false;
    }
    return false;
  } catch (error) {
    console.error('Error in checking app installed', error);
    return false;
  }
};
